<main class="component-field-itc">
	<!-- <section *ngIf="!isLabeled && !isTabeled" [class.tabeled]="!isTabeled" class="ifc-section-external-icon">
  <div *ngIf="isRequired"  [class.ifc-filled]="valueToReturn" class="ifc-light"></div>
</section> -->
	<label
		class="component-field-input-text-condensed"
		[class.tabeled]="!isTabeled"
		[class.ifc-labeled]="isLabeled"
		[class.ifc-tabeled]="isTabeled"
		[class.ifc-disabled]="isDisabled"
		[class.ifc-touched]="isTouched"
		[class.ifc-error]="hasError"
		[class.ifc-valid]="isValidIcon"
	>
		<!-- <span  [class.w-6]="!isLabeled && !isTabeled"></span> -->
		<section class="ifc-section-body">
			@if (!isTabeled) {
				<p
					class="component-field-itc-label"
					[class.tabeled]="!isTabeled"
					[class.ifc-tabeled]="isLabeled"
				>
					{{ labelValue }}
				</p>
			}
			<input
				#inputData
				[disabled]="isDisabled || isLabeled || isTabeled"
				class="ifc-input"
				type="text"
				(focus)="focusIn()"
				(blur)="focusOut()"
				[placeholder]="placeholder"
				(keyup)="inputKeyUpEvent($event)"
			/>
			<div class="ifc-focus-marker">&nbsp;</div>
		</section>
		@if (isLabeled && copy && !isTabeled) {
			<section
				title="Copiar!"
				(click)="copyToClipboard($event)"
				class="ifc-section-icon ico-copy-labeled cursor-pointer"
			>
				<lbca-icon name="lucide:copy" size="small" color="gray" />
			</section>
		}
		<!-- <span  [class.w-6]="isLabeled && !isEditable"></span> -->
		@if (componentFilling) {
			<span
				class="transition duration-400 ease-in-out"
				[ngStyle]="{ width: componentFilling }"
			></span>
		}
		@if (!componentFilling && !isLabeled && !isTabeled && (hasError || isValidIcon)) {
			<section class="ifc-section-icon">
				<div class="icon-box ifc-icon-validation"></div>
			</section>
		}
		@if (!isLabeled && !isTabeled && copy) {
			<section
				title="Copiar!"
				(click)="copyToClipboard($event)"
				class="ifc-section-icon cursor-pointer"
			>
				<lbca-icon name="lucide:copy" size="small" color="gray" />
			</section>
		}
		@if (isLabeled && isEditable) {
			<section class="if-section-icon">
				<lbca-icon name="lucide:pencil" size="small" class="size-2.5 text-primary"></lbca-icon>
			</section>
		}
		@if (inputComponetHelperIconStyle && !isLabeled && !isTabeled) {
			<section class="ifc-section-icon">
				<div [class]="'icon-box ' + inputComponetHelperIconStyle"></div>
			</section>
		}
		@if (maskIcon && !isLabeled) {
			<section class="ifc-section-icon">
				<div [class]="'icon-box ifc-icon-mask ' + maskIcon"></div>
			</section>
		}
		@if (inputComponetIconStyle && !isLabeled && !isTabeled) {
			<section class="ifc-section-icon">
				<div
					[ngClass]="{
						'icon-box': inputComponetIconSize === 'normal',
						'icon-box-sm': inputComponetIconSize === 'sm'
					}"
					[class]="inputComponetIconStyle"
				></div>
			</section>
		}
		@if (helperTextValue && !isLabeled && !isTabeled) {
			<p class="ifc-helper" title="{{ helperTextValue }}">
				{{ helperTextValue }}
			</p>
		}
	</label>
</main>

<ng-template #templateCopy>
	<div class="text-base text-font flex items-center justify-center show">
		Copiado!
		<lbca-icon name="emoji--smile" class="emojis-smile icon-box ml-[16px]"></lbca-icon>
	</div>
</ng-template>
